"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSingleReading = exports.deleteSequentialReadings = exports.default = void 0;
var _MapProcessingUtil = require("../../MapProcessingUtil");
function _getNewReadingsFromDeleteReadings(datFile, readingIndex, numberOfReadings) {
  const {
    interval,
    gpsreadings
  } = datFile;
  let readingFoundAndDeleted = false;
  const newGpsReadings = [];
  gpsreadings.forEach((gpsreading, i) => {
    const {
      StationId
    } = gpsreading;
    let newStationId = StationId;
    if (readingIndex === i) {
      readingFoundAndDeleted = true;
      return;
    }
    if (readingFoundAndDeleted && readingIndex + (numberOfReadings - 1) >= i) {
      readingFoundAndDeleted = true;
      return;
    }
    if (readingFoundAndDeleted || i > readingIndex) {
      newStationId = StationId - numberOfReadings * interval;
    }
    newGpsReadings.push(
    // eslint-disable-next-line prefer-object-spread
    Object.assign({}, gpsreading, {
      StationId: newStationId
    }) /* {
       ...gpsreading,
       StationId: newStationId
       } */);
    readingFoundAndDeleted = false;
  });
  (0, _MapProcessingUtil.updateGPSMeasurements)(newGpsReadings, {
    isUpdateInterpolatedCoords: true,
    index: readingIndex
  });
  return newGpsReadings;
}
const deleteSequentialReadings = (globalData, data, datIndex, numberOfReadings, readingIndex) => {
  const datFile = data[datIndex];
  const {
    fileName,
    endStn: originalEndStn,
    calcEnd: originalCalcEnd,
    interval,
    readingsCount: originalReadingsCount
  } = datFile;
  const endStn = originalEndStn - numberOfReadings * interval;
  const calcEnd = originalCalcEnd - numberOfReadings * interval;
  const readingsCount = originalReadingsCount - numberOfReadings;
  const {
    timeuuid
  } = globalData;
  const newDatFile = {
    ...datFile,
    gpsreadings: _getNewReadingsFromDeleteReadings(datFile, readingIndex, numberOfReadings),
    endStn,
    calcEnd,
    readingsCount,
    isDeleted: true
  };

  // Inject edited dat file into dat files
  const newData = data.map((dat, i) => {
    if (i !== datIndex) {
      return dat;
    }
    return newDatFile;
  });
  const newGlobalData = {
    ...globalData,
    MasterLST: {
      ...globalData.MasterLST,
      [fileName]: newDatFile
    }
  };
  const update = {
    job: timeuuid,
    readingsCount,
    calcEnd,
    endStn,
    dat: fileName
  };
  return [newData, newGlobalData, update];
};
exports.deleteSequentialReadings = deleteSequentialReadings;
const deleteSingleReading = (globalData, data, datIndex, gpsReadingIndex) => {
  return deleteSequentialReadings(globalData, data, datIndex, 1, gpsReadingIndex);
};
exports.deleteSingleReading = deleteSingleReading;
var _default = deleteSequentialReadings;
exports.default = _default;